import axios from 'axios';
import "./styles.css"
import { Component } from "react";
import { PRODUCTS } from "../../constants/const";
import ProductItemCard from './productItemCard';

export default class ProductGallery extends Component {
    constructor (props) {
        super(props); 
        this.state = {
            isLoading: true,
            products: [],
        }
    }


    getProductsAxios() {
        console.log("Getting stuff")

        axios
            .get(PRODUCTS)
            .then((res) => {
                this.setState({ products: res.data })   
                this.setState({isLoading: false})
                // console.log(res.data)
            })
            .catch((err) => {
                console.log(err);
            });
    }

    componentDidMount() {
        this.getProductsAxios()
    }


    render() {
        var products = this.state.products
        return (
            <div className='productItemCardContainer'>
                {products.map((product) => (
                     
                        <ProductItemCard product={product} />
                ))}
            </div>
        )
    }
} 